<template>
  <router-view />
</template>

<style>
@import "vue-select/dist/vue-select.css";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: var(--step--2);
}

body {
  overflow-x: hidden;
  overflow-y: hidden;
  margin: 0;
}

:root {
  /* Step -6: 5.3584px → 11.01px */

  --step-nico: clamp(0.5rem, 0.5rem + 0.3vi, 1.344rem);
  --step--6: clamp(0.3349rem, 0.305rem + 0.1497vi, 0.6881rem);
  /* Step -5: 6.43px → 13.7626px */
  --step--5: clamp(0.4019rem, 0.363rem + 0.1942vi, 0.8602rem);
  /* Step -4: 7.716px → 17.2032px */
  --step--4: clamp(0.4823rem, 0.432rem + 0.2512vi, 1.0752rem);
  /* Step -3: 9.2593px → 21.504px */
  --step--3: clamp(0.5787rem, 0.5138rem + 0.3243vi, 1.344rem);
  /* Step -2: 11.1111px → 26.88px */
  --step--2: clamp(0.6944rem, 0.6109rem + 0.4176vi, 1.68rem);
  /* Step -1: 13.3333px → 33.6px */
  --step--1: clamp(0.8333rem, 0.726rem + 0.5367vi, 2.1rem);
  /* Step 0: 16px → 42px */
  --step-0: clamp(1rem, 0.8623rem + 0.6886vi, 2.625rem);
  /* Step 1: 19.2px → 52.5px */
  --step-1: clamp(1.2rem, 1.0236rem + 0.8819vi, 3.2813rem);
  /* Step 2: 23.04px → 65.625px */
  --step-2: clamp(1.44rem, 1.2144rem + 1.1278vi, 4.1016rem);
  /* Step 3: 27.648px → 82.0313px */
  --step-3: clamp(1.728rem, 1.44rem + 1.4402vi, 5.127rem);
  /* Step 4: 33.1776px → 102.5391px */
  --step-4: clamp(2.0736rem, 1.7062rem + 1.8369vi, 6.4087rem);
  /* Step 5: 39.8131px → 128.1738px */
  --step-5: clamp(2.4883rem, 2.0203rem + 2.3401vi, 8.0109rem);
  /* Step 6: 47.7757px → 160.2173px */
  --step-6: clamp(2.986rem, 2.3904rem + 2.9778vi, 10.0136rem);

  /* Space */
  /* @link https://utopia.fyi/space/calculator?c=320,18,1.2,4096,42,1.25,5,2,&s=0.75|0.5|0.25,1.5|2|3|4|6,s-l&g=s,l,xl,12 */

  /* Space 3xs: 5px → 11px */
  --space-3xs: clamp(0.3125rem, 0.2807rem + 0.1589vi, 0.6875rem);
  /* Space 2xs: 9px → 21px */
  --space-2xs: clamp(0.5625rem, 0.4989rem + 0.3178vi, 1.3125rem);
  /* Space xs: 14px → 32px */
  --space-xs: clamp(0.875rem, 0.7797rem + 0.4767vi, 2rem);
  /* Space s: 18px → 42px */
  --space-s: clamp(1.125rem, 0.9979rem + 0.6356vi, 2.625rem);
  /* Space m: 27px → 63px */
  --space-m: clamp(1.6875rem, 1.4968rem + 0.9534vi, 3.9375rem);
  /* Space l: 36px → 84px */
  --space-l: clamp(2.25rem, 1.9958rem + 1.2712vi, 5.25rem);
  /* Space xl: 54px → 126px */
  --space-xl: clamp(3.375rem, 2.9936rem + 1.9068vi, 7.875rem);
  /* Space 2xl: 72px → 168px */
  --space-2xl: clamp(4.5rem, 3.9915rem + 2.5424vi, 10.5rem);
  /* Space 3xl: 108px → 252px */
  --space-3xl: clamp(6.75rem, 5.9873rem + 3.8136vi, 15.75rem);

  /* One-up pairs */
  /* Space 3xs-2xs: 5px → 21px */
  --space-3xs-2xs: clamp(0.3125rem, 0.2278rem + 0.4237vi, 1.3125rem);
  /* Space 2xs-xs: 9px → 32px */
  --space-2xs-xs: clamp(0.5625rem, 0.4407rem + 0.6091vi, 2rem);
  /* Space xs-s: 14px → 42px */
  --space-xs-s: clamp(0.875rem, 0.7267rem + 0.7415vi, 2.625rem);
  /* Space s-m: 18px → 63px */
  --space-s-m: clamp(1.125rem, 0.8867rem + 1.1917vi, 3.9375rem);
  /* Space m-l: 27px → 84px */
  --space-m-l: clamp(1.6875rem, 1.3856rem + 1.5095vi, 5.25rem);
  /* Space l-xl: 36px → 126px */
  --space-l-xl: clamp(2.25rem, 1.7733rem + 2.3835vi, 7.875rem);
  /* Space xl-2xl: 54px → 168px */
  --space-xl-2xl: clamp(3.375rem, 2.7712rem + 3.0191vi, 10.5rem);
  /* Space 2xl-3xl: 72px → 252px */
  --space-1: clamp(4.5rem, 3.5466rem + 4.7669vi, 15.75rem);
  /* Space 3xl-4xl: 108px → 336px */
  --space-2: clamp(6.75rem, 5.322rem + 6.5147vi, 21rem);
  /* Space 4xl-5xl: 192px → 504px */
  --space-3: clamp(12rem, 9.5rem + 9.375vi, 31.5rem);
  /* Space 4xl-5xl: 240px → 300px */
  --space-4: clamp(15rem, 12.5rem + 3.125vi, 18.75rem);

  /* Space 4xl-5xl: 404px → 900px */
  --space-5: clamp(24.25rem, 17.1412rem + 20.9786vi, 55.25rem);

  /* Space 6: 182px → 524px */
  --space-6: clamp(11.375rem, 8.125rem + 15.625vi, 32.75rem);

  --space-7: clamp(19.25rem, 17.125rem + 35.75vi, 39.75rem);

  --space-8: clamp(24rem, 22rem + 40vw, 50rem); /* Modal más grande */

  /* Custom pairs */
  /* Space s-l: 18px → 84px */
  --space-s-l: clamp(1.125rem, 0.7754rem + 1.7479vi, 5.25rem);
}
</style>
